import { render, staticRenderFns } from "./kartustock.vue?vue&type=template&id=4708395e&scoped=true"
import script from "./kartustock.vue?vue&type=script&lang=js"
export * from "./kartustock.vue?vue&type=script&lang=js"
import style0 from "./kartustock.vue?vue&type=style&index=0&id=4708395e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708395e",
  null
  
)

export default component.exports